@if (!asset) {
<div class="grid-loading-overlay">
  <span class="ag-icon ag-icon-loading" role="presentation" unselectable="on"></span>
</div>
}
@if (asset) {
<div class="row">
  <div class="col-10">
    @if (!minimizedView) {
    <app-insight-breadcrumbs [superCategory]="superCategory" [category]="category" [subCategory]="subCategory"
      [assetType]="assetType" [asset]="asset">
    </app-insight-breadcrumbs>
    }
  </div>
  <!-- <div class="col-2">
    <button nbButton ghost status="primary" class="history-button" (click)="openHistory()">
      <fa-icon icon="clock-rotate-left"></fa-icon>
    </button>
  </div> -->
</div>
}


@if (asset) {
<div class="row">
  <!-- LEFT SIDE -->
  <div class="col-4 sheet">
    <!-- PICTURES -->
    @if (settings.dynamicEl?.length) {
    <nb-card class="info">
      <nb-card-body class="p-0 pictures-container">
        <div class="p-0 main-image" [ngStyle]="{ 'background-image': 'url(' + settings.dynamicEl[0].src + ')' }">
          <lightgallery [settings]="settings" [onInit]="onInit"></lightgallery>
          <button nbButton class="see-photos" status="primary" (click)="openGallery()">
            {{ 'theme.see-pictures' | translate }} ({{ settings.dynamicEl.length }})
          </button>
        </div>
      </nb-card-body>
    </nb-card>
    }
    <nb-card class="info">
      <nb-card-body class="asset-card-header">
        <div class="info-label row">
          <div class="sheet-tag col-12">
            {{'Asset-sheet' | translate}}
          </div>
        </div>
        {{ asset | ngxAssetLocation }}
      </nb-card-body>
      <nb-card-body class="p-0">
        <nb-list class="info-list">
          <nb-list-item>
            <div class="name">
              {{ "reports.site-report.defaults.columns.asset_label" | translate }}
            </div>
            <div class="value">
              {{ asset?.label }}
            </div>
          </nb-list-item>
          <!-- Quantity -->
          <nb-list-item>
            <div class="name">
              {{ "pages.insight.asset.quantity" | translate }} ({{
              asset | ngxAssetQuantity
              }})
            </div>
            <div class="value">
              {{ asset.quantity }}
            </div>
          </nb-list-item>
          <!-- Installation year -->
          <nb-list-item>
            <div class="name">
              {{ "pages.insight.asset.installation_year" | translate }}
              @if (asset.replacement_of && asset.installation_year >= currentYear) {
              <div class="name-2">
                ({{ "Source : Asset replacement" | translate }})
              </div>
              } @else if (asset.installation_year < currentYear) { <div class="name-2">
                ({{ "Current age" | translate }}: {{currentYear - asset.installation_year}} {{ (currentYear -
                asset.installation_year) === 1 ? ("year" | translate) : ("years" | translate) }})
            </div>
            }
  </div>
  <div class="value">{{ asset && asset.installation_year > 1 ? asset.installation_year : '-' }}</div>
  </nb-list-item>
  <!-- Notation -->
  @if (note !== null) {
  <nb-list-item>
    <div class="name">
      {{ "pages.insight.asset.last-technical-state-assessment" | translate }}
      @if (lastNotation) {
      <div class="name-2">
        {{ getLastNotationInfo() }}
      </div>
      }
    </div>
    @if (lastNotation) {
    @if (asset.installation_year > currentYear) {
    <div class="value">
      -
    </div>
    }
    @if (!asset.replacement_of && asset.installation_year <= currentYear) { <div class="value">
      {{ "pages.insight.asset.out-of" | translate: { note: note }
      }}<br />
      ({{ technicalStateLabel }})
</div>
}
} @else {
<div class="value waiting">
  {{ 'Waiting' | translate}}
</div>
}
</nb-list-item>
}
<!-- Année de fin de vie théorique -->
<nb-list-item>
  <div class="name">
    {{ "Theoretical end of life" | translate }}
    <div class="name-2">
      {{ "without investment" | translate }}
    </div>
  </div>
  <div class="value">
    {{ asset.end_of_life }}
  </div>
</nb-list-item>
<nb-list-item>
  <div class="name">
    {{ "Theoretical lifetime for the asset type" | translate }}
  </div>
  <div class="value">
    {{ asset.asset_type_object.expected_duration }} {{ "years" | translate }}
  </div>
</nb-list-item>
<nb-list-item>
  <div class="name">
    {{ "Asset type" | translate }}
  </div>
  <div class="value asset-type-value">
    {{ asset.asset_type_object.name }}
  </div>
</nb-list-item>
<!-- See More Button -->
<nb-list-item class="see-more-container" (click)="seeMoreToggle()">
  @if(!seeMore) {
  <span>
    {{ 'pages.energy.initiative.labels.more_details' | translate }}
  </span>
  }
  @else {
  <span>
    {{ 'pages.energy.initiative.labels.less_details' | translate }}
  </span>
  }
</nb-list-item>

@if(seeMore) {
<nb-list-item>
  <div class="name">
    {{ "Last change" | translate }}
  </div>
  <div class="value">
    @if (lastModificationDate && lastModificationUser) {
    {{ lastModificationUser }}, {{ "the" | translate }} {{ lastModificationDate | date:'dd MMM yy' }}
    } @else {
    -
    }
  </div>
</nb-list-item>
}

@if(seeMore) {
<nb-list-item>
  <div class="name">
    {{ "Zone details" | translate }}
  </div>
  <div class="value">
    {{ asset.zone_details || '-' }}
  </div>
</nb-list-item>
}

@if(seeMore) {
<nb-list-item>
  <div class="name">
    {{ "Brand" | translate }}
  </div>
  <div class="value">
    {{ asset.brand || '-' }}
  </div>
</nb-list-item>
}

@if(seeMore) {
<nb-list-item>
  <div class="name">
    {{ "Model" | translate }}
  </div>
  <div class="value">
    {{ asset.model || '-' }}
  </div>
</nb-list-item>
}

@if(seeMore && asset.asset_type_object.power_support) {
<nb-list-item>
  <div class="name">
    {{ "Power" | translate }}
  </div>
  <div class="value">
    {{ asset.power || '-' }}
  </div>
</nb-list-item>
}

@if(seeMore && asset.asset_type_object.power_source_support) {
<nb-list-item>
  <div class="name">
    {{ "Related energy" | translate }}
  </div>
  <div class="value">
    {{ asset.power_source || '-' }}
  </div>
</nb-list-item>
}

@if(seeMore) {
<nb-list-item>
  <div class="name">
    {{ "asset.maintenance_code" | translate }}
  </div>
  <div class="value">
    {{ asset.maintenance_code || '-' }}
  </div>
</nb-list-item>
}

</nb-list>
</nb-card-body>
</nb-card>
@if (investments.length) {
<div class="macaron invest">
  <span class="macaron-link" (click)="seeInvestments()">
    {{ "{investNb} linked invest" | translate: {investNb: investments.length} }}
  </span>
  <span class="invest-budget">
    {{ getInvestBudget(investments) }}
  </span>
</div>
}
<!-- @if (opexManagementEnabled$ | async) {
<div class="macaron global-cost" [nbTooltip]="'pages.insight.asset.global-cost-tooltip' | translate"
  nbTooltipStatus="basic" (click)="openCostDialog()">
  <span class="macaron-link">
    € {{ "Global cost" | translate }}
  </span>
</div>
} -->
@if (asset.initiatives.length) {
<div class="macaron-bis action row">
  <div class="macaron-link col-8" (click)="seeActions(asset.initiatives)">
    {{ "{actionNb} linked action" | translate: {actionNb: asset.initiatives.length} }}
  </div>
  <div class="action-savings col-4">
    @if (getActionsSavings(asset.initiatives) < 0) { <span class="up">
      <fa-icon icon="arrow-up-right"></fa-icon>
      </span>
      }
      @if (getActionsSavings(asset.initiatives) > 0) {
      <span class="down">
        <fa-icon icon="arrow-down-right"></fa-icon>
      </span>
      }
      {{ getActionsSavings(asset.initiatives) | number }} {{"kWh" |translate}}
  </div>
</div>
}
@if (docCount > 0) {
<div class="macaron doc">
  <span class="macaron-link" (click)="seeDocuments()">
    {{ "{count} linked documents" | translate: {count: docCount} }}
  </span>
</div>
}
</div>
<!-- RIGHT SIDE -->
<div class="col-8">
  <div class="nomenclature-breadcrumbs">{{ superCategory.name }} > {{ category.name}} > {{ subCategory.name }} > <u>{{
      assetType.name }}</u></div>
  <nb-card class="tabs">
    <nb-card-body>
      <h2 class="impact-title">
        {{ 'pages.insight.asset.lifecycle' | translate }}
      </h2>
      <!-- LIFECYCLE -->
      <ng-container>
        <app-lifecycle-chart [asset]="asset" [allowZoom]="true" [boxShadow]="false"></app-lifecycle-chart>
        @if (lifetimeVsTheoricalPercent < 0) { <div class="lifetime-vs-theorical ms-5 ps-5 my-3">
          {{ "Total lifetime: {percent} vs therorical lifetime" | translate:{percent: lifetimeVsTheoricalPercent} }}@if
          (emissionsExcess) {
          ,
          {{ "ie an excess excess of GHG emissions of {emissions} kg CO²" | translate:{emissions: emissionsExcess} }}
          (<span class="more-info" (click)="openEnvironmentalProfiles()">{{ "more info" | translate }}</span>)
          }
</div>
}
</ng-container>
</nb-card-body>
</nb-card>
<!-- MAY BE DELETED LATER  -->
<!-- @if (asset && energyEnabled && visible) {
      <div class="row">
        <div class="col">
          <app-site-asset-consumptions-chart [asset]="asset"></app-site-asset-consumptions-chart>
        </div>
      </div>
    } -->
@if (asset.comments) {
<nb-card class="comments">
  <div class="title">{{ 'pages.insight.investment.comments' | translate }}</div>
  <div class="comment-text">
    {{ asset.comments }}
  </div>
</nb-card>
}
@if (asset && visible) {
<div class="row">
  <div class="col">
    <app-asset-projects-timeline [asset]="asset"></app-asset-projects-timeline>
  </div>
</div>
}
@if (linkedAssets?.length) {
<div class="row">
  <app-linked-assets-with-pictures [assets]="linkedAssets"></app-linked-assets-with-pictures>
</div>
}
@if (asset && defaults) {
<app-defaults-list [defaults]="defaults"></app-defaults-list>
}
@if ((opexManagementEnabled$ | async) && opexItems.length > 0) {
<nb-card class="opex-history">
  <nb-card-body>
    <h2 class="impact-title">
      {{ "Historique OPEX" | translate }} {{ opexYearRange }}
    </h2>
    <nb-list>
      @for (opex of opexItems; track opex.id) {
      <nb-list-item class="opex-history-item">
        <span class="opex-label">{{ opex.label }}</span>
        <span class="opex-type">{{ opex.type_display }}</span>
        <span class="opex-year">{{ opex.year }}</span>
        <span class="opex-amount">{{ formatOpexAmount(+opex.amount) }}</span>
      </nb-list-item>
      }
    </nb-list>
  </nb-card-body>
</nb-card>
}
</div>
</div>
}

@if (showAssetFormDrawer && asset) {
<app-asset-form-drawer [asset]="asset" (drawerClosed)="closeAssetFormDrawer()"
  (toggleChanged)="onAssetFormDrawerToggleChanged($event)"></app-asset-form-drawer>
}

@if (showInvestmentsDrawer && asset) {
<app-investment-list-drawer [visible]="showInvestmentsDrawer" [investmentData]="investments" [assetId]="asset.id"
  [asset]="asset" (drawerClosed)="closeInvestmentsDrawer()" (investmentSelected)="onInvestmentSelected($event)"
  (investmentsAttached)="onInvestmentsAttached($event)"></app-investment-list-drawer>
}